import React, { ReactElement } from 'react';
import { useForm } from 'react-hook-form';

import { InspectorFormProvider, LogDataFormGroup } from '../../components';
import { useCouponContext } from '../../contexts';
import { DocumentInspectorProps, DocumentNode } from '../../types';
import { CouponProps } from './Coupon';
import { IdFormGroup } from './CouponInspector/IdFormGroup';

export function CouponInspector({
  value,
  onChange,
}: DocumentInspectorProps<CouponProps>): ReactElement {
  return (
    <CouponInspectorContent value={value} onChange={onChange} />
  );
}

function CouponInspectorContent({
  value,
  onChange,
}: DocumentInspectorProps<CouponProps>): ReactElement {
  const { id: cartCouponMoldId, productCouponMoldId } = value.props ?? {};

  const form = useForm<CouponProps>({
    defaultValues: value.props,
    mode: 'onBlur',
  });

  const handleWrapBlock = (couponMoldIds: string[], productCouponMoldId: string[]): void => {
    if (couponMoldIds.length === 0 && productCouponMoldId.length === 0) {
      return;
    }

    const focusedNewCouponMoldsNode: DocumentNode<CouponProps> = {
      ...value,
      children: [{
        key: null,
        type: 'image',
        props: {},
        children: [],
      }],
      props: {
        ...value.props,
        id: couponMoldIds.join(', '),
        productCouponMoldId: productCouponMoldId.join(', '),
        canChildFocus: true,
      },
    };

    setTimeout(() => {
      const newCouponMoldsNode: DocumentNode<CouponProps> = {
        ...focusedNewCouponMoldsNode,
        props: {
          ...focusedNewCouponMoldsNode.props,
          canChildFocus: false,
        },
      };
      form.reset(newCouponMoldsNode.props);
      onChange(newCouponMoldsNode);
    }, 10);

    onChange(focusedNewCouponMoldsNode);
  };

  return (
    <InspectorFormProvider value={value} form={form} onChange={onChange}>
      <LogDataInput value={value} />
      <IdFormGroup
        cartCouponMoldId={cartCouponMoldId}
        productCouponMoldId={productCouponMoldId}
        onChange={handleWrapBlock}
      />
    </InspectorFormProvider>
  );
}

function LogDataInput({ value }: { value: DocumentNode<CouponProps> }): ReactElement {
  const { setLogData } = useCouponContext();
  const { children, ...others } = value ?? {};

  return (
    <LogDataFormGroup
      nodeKey={value?.key}
      {...setLogData?.(others)}
    />
  );
}

